import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { createTextMaskInputElement } from 'text-mask-core'
import { object } from 'common/helpers'


export const convertStringMask = (mask) => (
  mask.split('').map((char) => {
    if (char === '9') {
      return /\d/
    }
    if (char === 'a') {
      return /[A-Za-z]/
    }

    return char
  })
)

class MaskedInput extends PureComponent {

  static propTypes = {
    inputRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({
        current: PropTypes.any,
      }),
    ]),
    mask: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array,
      PropTypes.func,
      PropTypes.bool,
      PropTypes.shape({
        mask: PropTypes.oneOfType([ PropTypes.array, PropTypes.func ]),
        pipe: PropTypes.func,
      }),
    ]).isRequired,
    guide: PropTypes.bool,
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
    pipe: PropTypes.func,
    placeholderChar: PropTypes.string,
    keepCharPositions: PropTypes.bool,
    showMask: PropTypes.bool,
  }

  static defaultProps = {
    guide: false,
  }

  maskedValue = null

  componentDidMount() {
    this.initTextMask()
  }

  componentDidUpdate(prevProps) {
    const { mask, guide, pipe, placeholderChar, keepCharPositions, showMask, value } = this.props

    const isValueChanged                = this.maskedValue !== value // if value from props was changed by side scripts we need reinit mask script
    const isShowMaskChanged             = prevProps.showMask !== showMask
    const isMaskChanged                 = prevProps.mask.toString() !== mask.toString()
    const isGuideIsChanged              = prevProps.guide !== guide
    const isPlaceholderCharIsChanged    = prevProps.placeholderChar !== placeholderChar
    const isPipeIsChanged               = prevProps.pipe !== pipe
    const isKeepCharPositionsIsChanged  = prevProps.keepCharPositions !== keepCharPositions

    if (
      isValueChanged || isShowMaskChanged || isMaskChanged || isGuideIsChanged
      || isPlaceholderCharIsChanged || isPipeIsChanged || isKeepCharPositionsIsChanged
    ) {
      this.updateTextMask()
    }
  }

  componentWillUnmount() {
    if (this.textMaskInputElement) {
      this.textMaskInputElement = null
    }
  }

  onChange = (event) => {
    const { onChange } = this.props

    this.textMaskInputElement.update()

    // after .update() event.target.value changes (new value is masked)
    this.maskedValue = event.target.value

    if (onChange) {
      onChange(event)
    }
  }

  setInputRef = (ref) => {
    const { inputRef } = this.props

    this.inputRef = ref

    if (inputRef) {
      if (typeof inputRef === 'function') {
        inputRef(ref)
      }
      else {
        inputRef.current = ref
      }
    }
  }

  getOptions() {
    const { mask, guide, pipe, placeholderChar, keepCharPositions, showMask } = this.props

    return {
      guide,
      pipe,
      placeholderChar,
      keepCharPositions,
      showMask,
      mask: typeof mask === 'string' ? convertStringMask(mask) : mask,
      inputElement: this.inputRef,
    }
  }

  initTextMask() {
    const { value } = this.props

    if (this.inputRef) {
      const options = this.getOptions()

      if (!this.textMaskInputElement) {
        this.textMaskInputElement = createTextMaskInputElement(options)
      }

      this.textMaskInputElement.update(value, options)
    }
  }

  updateTextMask() {
    const { value } = this.props
    const options = this.getOptions()

    this.textMaskInputElement.update(value, options)
  }

  render() {
    const props = object.removeKeys(this.props, [
      'guide',
      'pipe',
      'placeholderChar',
      'keepCharPositions',
      'showMask',
      'mask',
      'inputRef',
      'value',
      'onChange',
    ])

    return (
      <input
        {...props}
        ref={this.setInputRef}
        onChange={this.onChange}
      />
    )
  }
}


export default MaskedInput
